import { ForwardIcon, CheckIcon } from '@heroicons/react/24/outline'

export default function StatusIndicatorV5({ isCompleted, isSkipped }) {
    return (
        <>
            {isCompleted === 0 && isSkipped === 0 && (
                <div className="w-6 h-6 rounded-full border border-gray-400 bg-white"/>
            )}

            {isSkipped === 1 && (
                <div className="w-6 h-6 rounded-full flex items-center justify-center border border-gray-200 bg-gray-200">
                    <ForwardIcon className="w-4 h-4 text-gray-500" />
                </div>
            )}

            {isCompleted === 1 && (
                <div className="w-6 h-6 rounded-full flex items-center justify-center border border-orange-400 bg-orange-400">
                    <CheckIcon className="w-4 h-4 text-white" />
                </div>
            )}
        </>
    )
}
